import { EntityBuilder } from '@decahedron/entity';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import { Company } from 'packages/company/entities/Company';
import { container } from 'tsyringe';
import isNil from 'common/support/isNil';
import axios from 'axios';
// Singleton holder
var _instance = null;
var CompanyService = /** @class */ (function () {
    function CompanyService() {
        this.company = new Company();
        this.users = [];
        this.companies = [];
        if (_instance) {
            return _instance;
        }
        _instance = this;
    }
    /**
     * Get a Company
     * @returns {Promise} - Resolves with index promise data {state, pagination}
     */
    CompanyService.prototype.getCurrentCompany = function (companyId) {
        var _this = this;
        var authenticator = container.resolve(Authenticator);
        var localStorageCompanyId = authenticator.getSelectedCompany();
        if (isNil(companyId) && isNil(localStorageCompanyId)) {
            return Promise.resolve(null);
        }
        return axios.get("/api/v2/companies/" + (companyId || localStorageCompanyId))
            .then(function (_a) {
            var data = _a.data;
            _this.company = EntityBuilder.buildOne(Company, data.data);
            return _this.company;
        });
    };
    /**
     * Update a Company
     * @returns {Promise} - Resolves with index promise data {state, pagination}
     */
    CompanyService.prototype.updateCompany = function (companyId, payload) {
        var _this = this;
        return axios.put("/api/v2/companies/" + companyId, payload.toJson())
            .then(function (_a) {
            var data = _a.data;
            _this.company = EntityBuilder.buildOne(Company, data.data);
            return _this.company;
        });
    };
    return CompanyService;
}());
export { CompanyService };
